export const navItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Products", path: "/products" },
  { label: "Applications", path: "/applications" },
  { label: "Export & Sourcing", path: "/export-sourcing" },
  { label: "Contact", path: "/contact" }
];
